import axios from 'axios';

const url = process.env.VUE_APP_MovieDB_URL;

const state = {
  popularMovie: [],
  trendingMovies: [],
  topRatedMovies: [],
  upcomingMovies: [],
  singleDetails: [],
  popularCelebs: [],
  celebDetails: [],
  queryMovie: {},
  queryPeople: {},
  isLoading: {},
  failedConnection: false,
};

const getters = {
  filterMovie(state) {
    let copyResults = [...state.queryMovie.results];
    if (copyResults.length > 5) {
      return copyResults.splice(0, 5);
    }
    return copyResults;
  },
  filterPeople(state) {
    let copyResults = [...state.queryPeople.results];
    if (copyResults.length > 5) {
      return copyResults.splice(0, 5);
    }
    return copyResults;
  },
};

const actions = {
  async fetchPopular({ commit, state }, query) {
    try {
      state.isLoading = { single: true, popular: true };
      // state.isLoading = true;
      const response = await axios.get(
        `${url}discover/movie?api_key=${
          process.env.VUE_APP_API_KEY
        }&sort_by=popularity.desc&page=${
          query.page
        }&with_genres=${query.genre || ''}&with_runtime.gte=${parseInt(
          query.runtime[0]
        )}&with_runtime.lte=${parseInt(
          query.runtime[1]
        )}&primary_release_date.gte=${
          query.release_from
        }&primary_release_date.lte=${query.release_to}`
      );

      state.isLoading = { single: false, popular: false };
      // state.isLoading = false;
      commit('fetchPopularMovie', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  async trendingMovies({ commit, state }, query) {
    try {
      state.isLoading = { single: true, trending: true };
      // state.isLoading = true;
      const response = await axios.get(
        `${url}discover/movie?api_key=${process.env.VUE_APP_API_KEY}&page=${
          query.page
        }&with_genres=${query.genre || ''}&with_runtime.gte=${parseInt(
          query.runtime[0]
        )}&with_runtime.lte=${parseInt(
          query.runtime[1]
        )}&primary_release_date.gte=${
          query.release_from
        }&primary_release_date.lte=${query.release_to}`
      );

      state.isLoading = { single: false, trending: false };
      // state.isLoading = false;
      commit('trendingMovies', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  async topRatedMovies({ commit, state }, query) {
    try {
      state.isLoading = { single: true, topRated: true };
      // state.isLoading = true;

      const response = await axios.get(
        `${url}discover/movie?api_key=${process.env.VUE_APP_API_KEY}&page=${
          query.page
        }&with_genres=${query.genre || ''}&with_runtime.gte=${parseInt(
          query.runtime[0]
        )}&with_runtime.lte=${parseInt(
          query.runtime[1]
        )}&primary_release_date.gte=${
          query.release_from
        }&primary_release_date.lte=${
          query.release_to
        }&vote_average.lte=${8.8}&sort_by=vote_average.desc&vote_count.gte=${10}`
      );

      state.isLoading = { single: false, topRated: false };
      // state.isLoading = false;
      state.failedConnection = false;
      commit('topRatedMovies', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  async upcomingMovies({ commit, state }, query) {
    try {
      state.isLoading = { single: true, upcoming: true };
      // state.isLoading = true;
      const response = await axios.get(
        `${url}discover/movie?api_key=${process.env.VUE_APP_API_KEY}&page=${
          query.page
        }&with_genres=${query.genre || ''}&with_runtime.gte=${parseInt(
          query.runtime[0]
        )}&with_runtime.lte=${parseInt(
          query.runtime[1]
        )}&primary_release_date.gte=${
          query.release_from
        }&primary_release_date.lte=${query.release_to}`
      );

      state.isLoading = { single: false, upcoming: false };
      // state.isLoading = false;
      state.failedConnection = false;
      commit('upcomingMovies', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  async fetchSingleMovie({ commit, state }, id) {
    try {
      state.isLoading = { single: true };
      // state.isLoading = true;
      const response = await axios.get(
        `${url}movie/${id}?api_key=${process.env.VUE_APP_API_KEY}&append_to_response=videos,credits,reviews,similar,external_ids,release_dates`
      );

      state.isLoading = { single: false };
      // state.isLoading = false;
      state.failedConnection = false;
      commit('fetchSingleDetails', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  async fetchPopularCelebrity({ commit, state }, query) {
    try {
      state.isLoading = { single: true };
      // state.isLoading = true;
      const response = await axios.get(
        `${url}person/popular?api_key=${process.env.VUE_APP_API_KEY}&page=${query.page}`
      );

      state.isLoading = { single: false };
      // state.isLoading = false;
      state.failedConnection = false;
      commit('fetchPopularCelebrity', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  async fetchCelebDetails({ commit, state }, id) {
    try {
      state.isLoading = { single: true };
      // state.isLoading = true;
      const response = await axios.get(
        `${url}person/${id}?api_key=${process.env.VUE_APP_API_KEY}&append_to_response=external_ids,combined_credits,known_for_department`
      );

      state.isLoading = { single: false };
      // state.isLoading = false;
      state.failedConnection = false;
      commit('fetchCelebDetails', response.data);
    } catch (err) {
      if (err.message === 'Network Error') {
        state.failedConnection = true;
      }

      return err.message;
    }
  },
  queryMovie({ commit, state }, { query, page }) {
    state.isLoading = { single: true };
    // state.isLoading = true;
    axios
      .get(
        `${url}search/movie?api_key=${process.env.VUE_APP_API_KEY}&query=${query}&page=${page}`
      )
      .then(({ data }) => {
        commit('queryMovie', data);
        state.failedConnection = false;
      })
      .catch((err) => {
        if (err.message === 'Network Error') {
          state.failedConnection = true;
        }

        return err.message;
      })
      .finally(() => {
        state.isLoading = { single: false };
        // state.isLoading = false;
      });
  },
  queryPeople({ commit, state }, { query, page = 1 }) {
    state.isLoading = { single: true };
    // state.isLoading = true;
    axios
      .get(
        `${url}search/person?api_key=${process.env.VUE_APP_API_KEY}&query=${query}&page=${page}`
      )
      .then(({ data }) => {
        commit('queryPeople', data);
        state.failedConnection = false;
      })
      .catch((err) => {
        if (err.message === 'Network Error') {
          state.failedConnection = true;
        }

        return err.message;
      })
      .finally(() => {
        state.isLoading = { single: false };
        // state.isLoading = false;
      });
  },
};

const mutations = {
  fetchPopularMovie(state, response) {
    state.popularMovie = response;
  },
  trendingMovies(state, response) {
    state.trendingMovies = response;
  },
  topRatedMovies(state, response) {
    state.topRatedMovies = response;
  },
  upcomingMovies(state, response) {
    state.upcomingMovies = response;
  },
  fetchSingleDetails(state, response) {
    state.singleDetails = response;
  },
  fetchPopularCelebrity(state, response) {
    state.popularCelebs = response;
  },
  fetchCelebDetails(state, response) {
    state.celebDetails = response;
  },
  queryMovie(state, response) {
    state.queryMovie = response;
  },
  queryPeople(state, response) {
    state.queryPeople = response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
